export default {
  pt: {},
};
